import { useEffect, useState } from "react";
import { DownloadCloud, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

const when = (iso) => (iso ? new Date(iso).toLocaleString("en-AU", { dateStyle: "medium", timeStyle: "short" }) : "never");

export const RelocImport = ({ onDone }) => {
  const [s, setS] = useState({});
  const load = () => api.get("/relocation/import").then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (!s.running) return undefined;
    const t = setTimeout(async () => {
      let data;
      try { ({ data } = await api.get("/relocation/import")); } catch { setS({ ...s }); return; }
      setS(data);
      if (!data.running) { onDone(); data.error ? toast.error(data.error) : toast.success("Relocation guides copied from the preview studio"); }
      else if (data.done !== s.done) onDone();
    }, 3000);
    return () => clearTimeout(t);
  }, [s, onDone]);

  const start = async () => {
    try { await api.post("/relocation/pull"); setS({ ...s, running: true, done: 0, current: "Signing in", error: null }); } catch (e) { toast.error(errMsg(e)); }
  };

  if (s.is_peer || !s.peer_url) return null;
  return (
    <div className="bg-[#3B1B48] text-[#FAF7F2] p-7 flex flex-wrap items-center gap-6" data-testid="reloc-import">
      <DownloadCloud className="w-7 h-7 text-[#C59B27]" strokeWidth={1.3} />
      <div className="flex-1 min-w-[220px]">
        <p className="eyebrow mb-1">Copy from the preview studio</p>
        {s.running ? (
          <p data-testid="reloc-import-progress" className="text-sm">{s.current === "Signing in" ? "Signing in to the preview studio…" : `Copying ${s.current}…`} {s.done || 0} of {s.total || "?"} guides · {s.files_copied || 0} files</p>
        ) : (
          <p data-testid="reloc-import-last" className="text-sm text-[#EFE6F3]/80">
            {s.error ? <span className="text-red-200">Last import failed: {s.error}</span> : `Last copied ${when(s.finished_at)}`} · Copies every relocation guide, chapter and file from the preview studio. Unchanged files are skipped.
          </p>
        )}
      </div>
      <Button data-testid="reloc-import-button" onClick={start} disabled={s.running} variant="outline" className="rounded-none border-[#C59B27] text-[#C59B27] bg-transparent hover:bg-[#C59B27] hover:text-[#1C181D]">
        {s.running ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Copying</> : s.finished_at ? "Copy again" : "Copy guides"}
      </Button>
    </div>
  );
};
